module.exports = require("@bechtel/client-assets/dist/images/empty_state_fitup_weld.svg");